import { render, staticRenderFns } from "./RegularCriteria.vue?vue&type=template&id=6fa75a86&scoped=true"
import script from "./RegularCriteria.vue?vue&type=script&lang=js"
export * from "./RegularCriteria.vue?vue&type=script&lang=js"
import style0 from "./RegularCriteria.vue?vue&type=style&index=0&id=6fa75a86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa75a86",
  null
  
)

export default component.exports